import React, {useState, Fragment, useEffect} from "react";
import api from "api";
import _ from "lodash";
import stateMap from "store/stateMap";
import { SetInitiative } from "store/dispatcher";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { popupEditInitiative } from "component/EditInitiative";
import { FillInitiativeButton, popupFillDetail } from "component/EditInitiative";

const checkpoints = {
    default : {
        'setup-role' : {name : 'Create at least One Role', level : 3, action : 'member-screen', hint : ''}
        ,'has-bga' : {name : 'Assign BGA to at Least One Role', level : 3, action : 'member-screen',hint : ''}
        ,'has-picture' : {name : 'Set initiative picture', level : 2, action : 'basic-popup',hint : ''}
        ,'period-complete' : {name : 'Define Initiative Timeframe', level : 2, action : 'basic-popup',hint : ''}
        ,'has-sat' : {name : 'Give SAT to participating role', level : 1, action : 'member-screen',hint : ''}
    }
    ,event : {
        'meta-visited' : {name : 'Provide Event Location, Organizer, and Media Info', level : 3, action : 'detail-popup',hint : ''}
        ,'period-complete' : {name : 'Enter Event Start & End Dates', level : 3, action : 'basic-popup',hint : ''}
        ,'event-time' : {name : 'Enter Event Start & End Times', level : 3, action : 'detail-popup',hint : ''}
        ,'has-picture' : {name : 'Upload Event Poster', level : 2, action : 'basic-popup',hint : ''}
        ,'has-sat' : {name : 'Assign SAT Points for Participation Roles', level : 1, action : 'member-screen',hint : ''}
        ,'has-event-category' : {name : 'Select Event Category', level : 1, action : 'detail-popup',hint : ''}
    }
    ,research : {
        'meta-visited' : {name : 'Define Research Type, Output, Field &amp; Goals', level : 3, action : 'detail-popup',hint : ''}
    }
}

const ChecklistMeter = connect(stateMap, {SetInitiative})((props) => {
    let navigate = useNavigate();
    
    const [isLoading, setIsLoading] = useState(true);

    const [initiativeCheckpoints, setInitiativeCheckpoints]  = useState([]);

    const [usedCheckpoint, setUsedCheckpoints]  = useState({});

    useEffect(() => {

        setUsedCheckpoints(_.merge(checkpoints.default, checkpoints[props.sent_initiative.InitiativeType]));

        api('/Initiative/Completeness', 'get', {
            initiative_id : props.sent_initiative.InitiativeID
            ,
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                setInitiativeCheckpoints(response.checkpoints);

                setIsLoading(false);
            })
            .catch(err => {
                setIsLoading(false);
            })
    }, [props.sent_initiative]);

    return (
        <div className="initiative-completeness-check">
            <h4 className="text-md mb-md font-semibold">CHECKLIST</h4>
            <p className="leading-text text-sm">Complete these steps to improve the visibility of your initiative.</p>
            <div className="check-meter-hold">
                <div className="check-meter-bar" style={{width : `${ Math.min(100, _.intersection(initiativeCheckpoints, Object.keys(usedCheckpoint)) .length / Object.keys(usedCheckpoint).length * 100) }%` }}>
                    <span className="check-meter-value">{ Math.min(100, Math.round(_.intersection(initiativeCheckpoints, Object.keys(usedCheckpoint)).length / Object.keys(usedCheckpoint).length * 100))  }%</span>
                </div>
            </div>
            <div className="checklists-box">
                {
                    [3,2,1].map((recommendationLevel) => (
                        <Fragment key={recommendationLevel}>
                            {
                            _.filter(usedCheckpoint, {level : recommendationLevel}).length > 0 && !isLoading
                            && <span className="block font-semibold text-xs mb-sm mt-md">
                                {recommendationLevel === 3 && 'Strongly Recommended'}
                                {recommendationLevel === 2 && 'Recommended'}
                                {recommendationLevel === 1 && 'Extra Details'}
                            </span>
                            }
                            <ul className="the-checks mb-md">
                                {
                                    !isLoading && Object.keys(usedCheckpoint).map((checkpointKey  ) => (
                                        usedCheckpoint[checkpointKey].level === recommendationLevel &&
                                        <li 
                                            className={`the-check relative ${checkpointKey} ${ _.indexOf(initiativeCheckpoints, checkpointKey) >= 0 ? '--done' : ''}`} 
                                            key={checkpointKey}>
                                            <span className="check-name">{usedCheckpoint[checkpointKey].name}</span>
                                            <a className="absolute inset" onClick={e => {
                                                e.preventDefault();

                                                switch(usedCheckpoint[checkpointKey].action)
                                                {
                                                    case 'member-screen':
                                                        navigate({
                                                            pathname    : 'member'
                                                            ,replace    : true
                                                        });
                                                        break;
                                                    case 'basic-popup':
                                                        popupEditInitiative(props.sent_initiative, (editedInitiative) => {
                                                            props.SetInitiative(editedInitiative)
                                                        });
                                                        break;
                                                    case 'detail-popup':
                                                        popupFillDetail(props.sent_initiative, (editedInitiative) => {
                                                            props.SetInitiative(editedInitiative)
                                                        });
                                                        break;
                                                }
                                            }}>

                                            </a>
                                        </li>
                                    ))
                                }
                                {
                                    isLoading && recommendationLevel === 3 && [0,1,2].map((i) => (
                                        <li className="the-check" key={i}><span className="check-name"><span className="skeleton"></span> </span></li>
                                    ))
                                }
                            </ul>
                        </Fragment>
                    ))
                }
            </div>
        </div>
    )
});

export {ChecklistMeter, checkpoints}